import { productNotAvailable } from '../product-not-available/product-not-available'

export function cannotBeAddedToCart(debtorPrice: number, status: string): boolean {
    return (isNaN(+debtorPrice) || productNotAvailable(status))
}
